import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()
const HomeRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Dashboard',
  component: LAYOUT,
  meta: {
    title: t('router.home'),
    icon: 'home'
  },
  children: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/views/home.vue'),
      meta: {
        title: t('router.home'),
        icon: 'card'
      }
    }
  ]
}

export default HomeRoute
